import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload';
import { CookiebeleidComponent } from './components/cookiebeleid/cookiebeleid.component';
import { InputDateComponent } from './components/input-date/input-date.component';
import { InputFileComponent } from './components/input-file/input-file.component';
import { DateValueAccessorDirective } from './directives/date-value-accessor.directive';
import { OptionalDirective } from './directives/optional.directive';
import { RequiredDirective } from './directives/required.directive';
import { BackbuttonGuard } from './guards/backbutton.guard';
import { FilterPipe } from './pipes/filter.pipe';
import { BrowserLocationService } from './services/browser-location.service';

const angularModules = [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    FileUploadModule
];

const sharedComponents = [
    DateValueAccessorDirective,
    OptionalDirective,
    InputDateComponent,
    RequiredDirective,
    CookiebeleidComponent
];

@NgModule({
    imports: [
        angularModules,
        TranslateModule.forChild()
    ],
    declarations: [
        sharedComponents,
        InputFileComponent,
        FilterPipe
    ],
    exports: [
        angularModules,
        sharedComponents,
        TranslateModule,
        InputFileComponent,
        FilterPipe
    ],
    providers: [
        BackbuttonGuard,
        BrowserLocationService
    ]
})
export class SharedModule { }
